
import axios from "axios"
import router from '../../router';

import { func } from '../../main';


const state = {
    OtherWorkList:[],
    PreferenceTypeList:[],
    OtherWorkNo: "",
    OtherWorkNoMoreData: false,
    UpdateOtherWorkList:true,
    Loading:false
};


const getters = {
    GetOtherWorkList(state:any) {
        return state.OtherWorkList;
    },
    GetPreferenceTypeList(state:any) {
        return state.PreferenceTypeList;
    },
  
    GetOtherWorkNo(state:any) {
        return state.OtherWorkNo;
    },
    GetOtherWorkNoMoreData(state:any) {
        return state.OtherWorkNoMoreData;
    },
    GetUpdateOtherWorkList(state:any) {
        return state.UpdateOtherWorkList;
    }
};

const mutations = {

    SetOtherWorkList(state:any, list:any) {
        state.OtherWorkList = list;
    },
    SetPreferenceTypeList(state:any, list:any) {
        state.PreferenceTypeList = list;
    },
    AddOtherWorkList(state:any, list:any) {
        state.OtherWorkList=state.OtherWorkList.concat(list);
    },
  
    SetOtherWorkNo(state:any, no:any) {
        state.OtherWorkNo = no;
    },
    SetOtherWorkNoMoreData(state:any, val:any) {
        state.OtherWorkNoMoreData = val;
    },
    SetUpdateOtherWorkList(state:any, val:any) {
        state.UpdateOtherWorkList = val;
    }
};

const actions = {
    GetPreferenceTypeListFromServer(context: any, Filter: any) {
        if (Filter == null) {
            Filter = { searchKey: "" };
        }
        if (state.Loading == true) {
            return;
        }
        context.commit("SetLoading", true);
        axios.get("OtherWork/GetPreferenceTypeList")
            .then((data: any) => {
                context.commit("SetLoading", false);
                context.commit("SetPreferenceTypeList", data.data);
            });
    },
    GetOtherWorkListFromServer(conext:any, Filter:any) {
        if (state.Loading == true) {
            return;
        }
        conext.commit("SetLoading", true);
        axios.get("OtherWork/GetOtherWorkList", {
            params: {
                page: Filter.pageId,
                filterId: Filter.filterId,
                searchKey:Filter.searchKey,
                projectId: Filter.projectId,
                userId: Filter.userId,
                preferenceTypeId: Filter.preferenceTypeId,
                date: Filter.date
            }
        }).then((data: any) => {
            conext.commit("SetLoading", false);
            conext.commit('SetUpdateOtherWorkList', false);

                if (data.data.length < 1 && Filter.pageId>1) {
                    conext.commit("SetOtherWorkNoMoreData", true);
                    return;
                }
                else if(data.data.length < 1 && Filter.pageId==1)
                {
                    conext.commit("SetOtherWorkNoMoreData", true);
                    conext.commit("SetOtherWorkList", data.data);
                }
                if (Filter.pageId == 1) {
                    conext.commit("SetOtherWorkNoMoreData", false);
                    conext.commit("SetOtherWorkList", data.data);
                }
                else {
                    conext.commit("SetOtherWorkNoMoreData", false);
                    conext.commit("AddOtherWorkList", data.data);
                }
            });
    },
    ClearOtherWorkList(context: { commit: (arg0: string, arg1: never[]) => void; }) {
        context.commit("SetOtherWorkList", []);
    },
   
    CreateOtherWork(context: { commit: (arg0: string, arg1: boolean) => void; }, item: any) {
        context.commit("SetLoading", true);
        axios.post('OtherWork/CreateOtherWork', item).then((response: any) => {
            console.log(response);

            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a: { errorMessage: any; }) => a.errorMessage);
                func.showErrorMessage(res.join('\n'));
            }
            else {
                func.showSuccessMessage("با موفقیت ثبت شد.")
                context.commit('SetUpdateOtherWorkList', true);
                setTimeout(function () { router.push('/OtherWorkList'); }, 1500);
               
            }
            context.commit("SetLoading", false);
        }, (error: any) => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        }).catch((error: any) => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },
    EditOtherWork(context: { commit: (arg0: string, arg1: boolean) => void; }, item: { description: null; subject: any; }) {
        context.commit("SetLoading", true);
        if (item.description == null) {
            item.description = item.subject;
        }
        axios.post('OtherWork/EditOtherWork', item).then((response: any) => {
            console.log(response);
            if (response.status == 400 || response.data.success == false) {
                const res = response.data.errors.map((a: { errorMessage: any; }) => a.errorMessage);
                func.showErrorMessage(res.join('\n'));
            }
            else {
                func.showSuccessMessage("با موفقیت ثبت شد.")
                context.commit('SetUpdateOtherWorkList', true);
                setTimeout(function () { router.push('/OtherWorkList'); }, 1500);
            }
            context.commit("SetLoading", false);
        }, (error: any) => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        }).catch((error: any) => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },

};

export default {
    state,
    getters,
    mutations,
    actions
};
